import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import giftBoxImage from "@/assets/gift-box-original-transparent.png";

const HeroSection = () => {
  return (
    <section className="hero-gradient py-20 md:py-32 px-4 overflow-hidden">
      <div className="container max-w-6xl mx-auto flex flex-col items-center text-center">
        {/* Bouncing gift box */}
        <div className="relative mb-10">
          <motion.div
            animate={{ y: [0, -20, 0] }}
            transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
          >
            <img
              src={giftBoxImage}
              alt="Hintsly gift box — create your wishlist and share gift hints"
              width={192}
              height={192}
              fetchPriority="high"
              className="w-36 h-36 md:w-48 md:h-48 object-contain drop-shadow-2xl"
              loading="eager"
            />
          </motion.div>
          {/* Shadow */}
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 w-24 h-4 bg-foreground/10 rounded-full blur-md animate-float-shadow" />
        </div>

        <motion.h1
          className="text-4xl md:text-6xl font-bold text-foreground leading-tight max-w-3xl"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Give the gift they'll{" "}
          <span className="text-gradient-brand">actually love.</span>
        </motion.h1>

        <motion.p
          className="mt-5 text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15 }}
        >
          We've all done the awkward smile. The "oh wow, I love it!" when you
          definitely don't love it. Hintsly fixes that — it's a free wishlist
          that works with any store, so your people always know what you
          actually want. Less guessing. Less waste. More genuine joy.
        </motion.p>

        <motion.div
          className="mt-8 flex flex-col sm:flex-row gap-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <Button variant="hero" asChild>
            <Link to="/wishlist">Create my free wishlist</Link>
          </Button>
          <Button variant="hero-outline" asChild>
            <Link to="/dashboard?spark=1">Discover my gift style</Link>
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
